import { CenteringDiv, FlexRowDiv, H1, H3 } from 'components/generic/HomePageComponents'
import { InlineContainer, HeroSubtitle, HeroButton } from './Styled'
import { trackClickEvent } from 'utils/Analytics'
import { useContext } from 'react'
import { AppContext } from 'contexts/AppContext'
import Link from 'next/link'

const HeroContainer = ({
  heroHeading,
  heroSubHeading,
  findProviderButtonText,
  heroLink,
  seekerLookingFor,
}) => {
  const { domain } = useContext(AppContext)

  const onHeroButtonClick = () => {
    trackClickEvent(domain, 'homepage_hero_button')
  }

  return (
    <FlexRowDiv bg='inverseColor'>
      <CenteringDiv mt={{ _: '100px', tablet: '100px', desktop: '58px' }} ml='30px' mr='30px'>
        <H1 color='white' mb='0px' textAlign={{ _: 'left', desktop: 'center' }}>
          {heroHeading}
        </H1>
        <H3
          color='white'
          mb='0px'
          mt='11px'
          textAlign={{ _: 'left', desktop: 'center' }}
          width={{ desktop: '50%' }}
        >
          {heroSubHeading}
        </H3>
        <Link href={heroLink} passHref={true}>
          <HeroButton
            onClick={onHeroButtonClick}
            fontSize={{ _: '16px', tablet: '18px', desktop: '24px' }}
            rel='nofollow'
          >
            {findProviderButtonText}
          </HeroButton>
        </Link>
        <InlineContainer border='1px red solid'>
          <HeroSubtitle
            color='white'
            mb={{ _: '40px', desktop: '90px' }}
            maxWidth={{ _: '350px', desktop: '70vw' }}
            textAlign={{ _: 'left', desktop: 'center' }}
            dangerouslySetInnerHTML={{ __html: seekerLookingFor }}
          />
        </InlineContainer>
      </CenteringDiv>
    </FlexRowDiv>
  )
}

export default HeroContainer
